export const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/** Retry only read requests. POSTs may have committed even when their response was lost. */
export async function fetchRead(
  input: RequestInfo | URL,
  options: RequestInit = {},
): Promise<Response> {
  if (options.method && options.method.toUpperCase() !== "GET") {
    throw new Error("fetchRead only supports GET requests");
  }
  for (let attempt = 0; ; attempt++) {
    let wait = 500 * 2 ** attempt;
    try {
      const response = await fetch(input, options);
      if (attempt === 2 || ![429, 503].includes(response.status)) return response;
      const retryAfter = response.headers.get("Retry-After");
      if (retryAfter) {
        const seconds = Number(retryAfter);
        const milliseconds = Number.isFinite(seconds)
          ? seconds * 1000
          : Date.parse(retryAfter) - Date.now();
        if (Number.isFinite(milliseconds)) wait = Math.min(30_000, Math.max(0, milliseconds));
      }
    } catch (error) {
      if (
        attempt === 2 ||
        options.signal?.aborted ||
        (typeof error === "object" &&
          error !== null &&
          "name" in error &&
          error.name === "AbortError")
      )
        throw error;
    }
    await delay(wait);
  }
}
